export class FolderContent{
    public Prefix!: string;
    public Folders!: FolderContent[];
    public Files!: FileInfo[];
}

export class FileInfo{
    public Name!: string;
    public Path!: string;
}